// App.js or wherever you want to use the button
import React from "react";
import { Link } from "react-router-dom";
import CatalogueNavbar from "./components/CatalogueNavbar";
import FooterCatalogue from "./components/FooterCatalogue";
function FabricCatalogue() {
  const fabrics = [
    {
      image: "/1.png", // Assuming the image is in the public/fabrics folder
      name: "Pique",
      description:
        "Knitted with raised honeycomb loops, offering textured structure and breathability; ideal for casual, polo-style garments.",
      link: "/Fabrics/Pique",
    },
    {
      image: "2.png",
      name: "Interlock",
      description:
        "Double-knit with intermeshed layers yielding uniform, stable structure; suitable for activewear with a smooth, reversible finish.",
      link: "/Fabrics/Interlock",
    },
    {
      image: "3.png",
      name: "Single Jersey",
      description:
        "Single needle-bed knit creating uniform, lightweight loops; renowned for softness and drape in all-season designs.",
      link: "/Fabrics/SingleJersey",
    },
    {
      image: "4.png",
      name: "Jacquard",
      description:
        "Multi-feed knit producing intricate, precise patterns; engineered for refined textures and versatile, year-round style.",
      link: "/Fabrics/Jacquard",
    },
    {
      image: "6.png",
      name: "Loop Knit",
      description:
        "Uniform open-loop knit creates an airy, porous structure; offering superior breathability for relaxed, casual wear across seasons.",
      link: "/Fabrics/LoopKnit",
    },
    // {
    //   image: "Terry.jpg",
    //   name: "Terry",
    //   description:
    //     "Double-faced knit with abundant loop piles engineered for moisture absorption; delivering plush texture with enduring structure.",
    //   link: "/Fabrics/Terry",
    // },
    {
      image: "FleeceKnit.png",
      name: "Fleece",
      description:
        "Brushed, double-knit fleece with dense loops trapping heat; engineered for superior warmth in cold, winter conditions.",
      link: "/Fabrics/FleeceKnit",
    },
    {
      image: "12.png",
      name: "Rib Knit",
      description:
        "Alternating knit and purl stitches create vertical ribs; engineered for elasticity and shape retention in form-fitting garments, all seasons.",
      link: "/Fabrics/RibKnit",
    },
    {
      image: "13.png",
      name: "Velour",
      description:
        "Knitted with cut-loop piles on one face, forming a plush, velvety texture; ideal for upscale, comfortable wear during cooler months.",
      link: "/Fabrics/Velour",
    },
    {
      image: "14.png",
      name: "Pointelle",
      description:
        "Selective yarn omission creates intricate openwork patterns; engineered for lightweight texture and refined detailing, adaptable for any season.",
      link: "/Fabrics/Pointelle",
    },
    {
      image: "15.png",
      name: "Tie Dye",
      description:
        "Resist-dyed plain knit yields vibrant marbled patterns; standard structure enhanced by dynamic color effects.",
      link: "/Fabrics/TieDye",
    },

    {
      image: "16.png",
      name: "Waffle",
      description:
        "Grid-like knit alternating raised and recessed loops creates textured surface; engineered for durability and enhanced insulation in cooler climates.",
      link: "/Fabrics/Waffle",
    },
    {
      image: "Slub.jpg",
      name: "Slub Knit",
      description:
        "Intentionally irregular yarn thickness produces a textured knit with varied loop diameters; delivering a rustic, handcrafted aesthetic across seasons.",
      link: "/Fabrics/SlubKnit",
    },
    {
      image: "18.png",
      name: "Ottoman",
      description:
        "Tightly structured knit with pronounced ribbing creates embossed lines; engineered for durability and refined texture, ideal for cooler, structured garments.",
      link: "/Fabrics/Ottoman",
    },
    {
      image: "BirdsEye.png",
      name: "Birds Eye",
      description:
        "Fine, recurring motifs mimic tiny eyes within knit loops; engineered for subtle decorative texture, adaptable for casual, all-season wear.",
      link: "/Fabrics/BirdsEye",
    },

    {
      image: "Popcorn.png",
      name: "Popcorn",
      description:
        "Distinct raised loops form rounded protrusions; engineered for a playful, tactile surface, adding depth to casual, seasonal designs.",
      link: "/Fabrics/Popcorn",
    },

    {
      image: "24.png",
      name: "Striper",
      description:
        "Alternating colored yarns interlaced in a consistent pattern yield defined horizontal bands; merging technical structure with vibrant design.",
      link: "/Fabrics/Striper",
    },

    {
      image: "26.png",
      name: "Needle Drop",
      description:
        "Selective stitch omission yields irregular openings; engineered for dynamic texture and visual interest in avant-garde, all-season creations.",
      link: "/Fabrics/NeedleDrop",
    },

    {
      image: "Melange.png",
      name: "Melange Fabrics",
      description:
        "Blended fibers in varied hues create a mottled knit; engineered for integrated texture with color shifts, suitable for every season",
      link: "/Fabrics/Melange",
    },
    // Add more fabrics as needed
  ];

  return (
    <div className="">
      <CatalogueNavbar></CatalogueNavbar>
      {/* Banner start */}
      <div
        className="h-[28vh] md:h-[50vh] bg-cover bg-center relative"
        style={{ backgroundImage: "url('/FabCatbanner.png')" }}
      >
        {/* Inner div positioned at the bottom left corner */}
        <div className="absolute bottom-[3vh] md:bottom-[10vh] left-[2vh] md:left-[10vh] p-3 text-white text-3xl md:text-4xl ">
          {/* Inner content here */}
          <p>
            Fabric
            <span className="ml-2 font-bold text-3xl md:text-4xl">
              Catalogue
            </span>
          </p>
        </div>
      </div>
      {/* Banner end */}
      {/* fabrics start */}

      <div className="w-full  pl-8 pr-8 pt-6 pb-6 md:pl-24 md:pr-24 md:pt-10 md:pb-10">
        {" "}
        <div className="flex flex-row items-center ">
          <img
            src="/Categories.svg" // Replace with your SVG file path
            alt="C"
            className="h-3 w-3 "
          />
          {/* Replace with your icon */}
          <p className="text-sm pl-2">KNITTED TO PERFECTION</p>
        </div>
        <div className="flex flex-wrap">
          {/* First Column (Responsive 50% width) */}
          <div className="w-full md:w-[40%] mt-2 -ml-1 text-4xl">
            Our Versatile<span className="font-bold"> Fabric Collections</span>
          </div>

          {/* Second Column (Responsive 50% width with button in top-right) */}
          <div className="w-[60%] p-4  relative hidden md:block">
            <a href="/Catalogue#ContactUs">
              <button className="flex items-center absolute right-0 top-0 rounded overflow-hidden bg-[#465b83] shadow-lg border-2 border-[#465b83]">
                {/* Contact Us Text Section */}
                <div className="bg-white text-[#465b83] px-2 py-1 text-sm rounded">
                  {" "}
                  {/* Reduced padding and smaller text */}
                  Contact Us
                </div>
                {/* Icon Section */}
                <div className="bg-[#465b83] p-1">
                  {" "}
                  {/* Reduced padding */}
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 25 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.69531 19.6176C7.39531 19.6176 7.19531 19.5119 6.99531 19.3007C6.59531 18.8783 6.59531 18.2446 6.99531 17.8222L16.9953 7.26117C17.3953 6.83873 17.9953 6.83873 18.3953 7.26117C18.7953 7.68361 18.7953 8.31727 18.3953 8.73971L8.39531 19.3007C8.19531 19.5119 7.99531 19.6176 7.69531 19.6176Z"
                      fill="white"
                    />
                    <path
                      d="M17.6953 18.5615C17.0953 18.5615 16.6953 18.139 16.6953 17.5054V9.05654H8.69531C8.09531 9.05654 7.69531 8.6341 7.69531 8.00044C7.69531 7.36678 8.09531 6.94434 8.69531 6.94434H17.6953C18.2953 6.94434 18.6953 7.36678 18.6953 8.00044V17.5054C18.6953 18.139 18.2953 18.5615 17.6953 18.5615Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </button>
            </a>
          </div>
        </div>
        <div className="mt-5 text-md">
          Our primary fabric products consist of a full range of single jersey,
          interlock, rib knit, fleece, pique, and waffle, along with melange and
          jacquard variations. We specialize in producing knitted cotton
          fabrics, including loop knit and slub knit, with counts from 20s to
          40s, available in various gauges.
        </div>
        <div className="mt-5">
          <div className="flex flex-row space-x-3">
            <div>
              <img
                src="/Categories.svg" // Replace with your SVG file path
                alt="C"
                className="md:h-3 md:w-3 h-14 w-14 -mt-4 md:mt-2"
              />
            </div>
            <div>
              <div className="font-bold text-sm">Special Finishes</div>
              <div>
                Bio-Washed, Mercerized, Gold Finish (Soft hand feel), Water
                Repellent, Anti-Bacterial, Wicking, UV Protection, Flame
                Retardant, Anti-Static, Moisture Management, Stretch Recovery.
              </div>
            </div>
          </div>
        </div>
        <div className="mt-5">
          <div className="flex flex-row space-x-3">
            <div>
              <img
                src="/Categories.svg" // Replace with your SVG file path
                alt="C"
                className="md:h-3 md:w-3 h-14 w-14 -mt-4 md:mt-2"
              />
            </div>
            <div>
              <div className="font-bold text-sm">Type of Products:</div>
              <div>
                All the below fabrics and Mixed knits of below fabrics. Please{" "}
                <span className="underline">
                  {" "}
                  <a href="/Catalogue#ContactUs">
                    get in touch with out fabric and garment experts
                  </a>
                </span>{" "}
                for any customization.
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* fabrics end */}
      {/* fabric card start */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-3 gap-6 p-6 md:pl-24 md:pr-24">
        {fabrics.map((fabric, index) => (
          <a
            key={index}
            href={fabric.link}
            className="flex flex-col items-center bg-white rounded-lg  overflow-hidden hover:scale-110 p-2 transition-shadow duration-300"
          >
            <img
              src={`/FabricCat/${fabric.image}`} // Assuming images are in the public/fabrics folder
              alt={fabric.name}
              className="w-full h-48 md:h-64 object-cover rounded-xl"
            />
            <div className=" p-1 pt-3 md:pt-2 md:p-4 ">
              <h3 className="text-xl font-semibold text-gray-800">
                {fabric.name}
              </h3>
              <div class="text-black h-[2%] w-8 mt-1"></div>
              <p className=" text-gray-600 font-brygada">
                {fabric.description}
              </p>
              <p className="text-black">
                Explore<span className="text-xl"> →</span>
              </p>
            </div>
          </a>
        ))}
      </div>

      {/* fabric card end */}
      {/* footer start */}
      <FooterCatalogue></FooterCatalogue>
      {/* footer end */}
    </div>
  );
}

export default FabricCatalogue;
